export default {
    transferList: {
        selectBytTasks: "Вибрати завдання побуту",
        byt: "побут",
        selectPromTasks: "Вибрати завдання прома",
        prom: "пром",
        selectAll: "Вибрати все",
        noSelectedElementsOperationError: "Не можна виконати операцію без вибору елементів",
        unselect: "Зняти виділення",
    }
}